function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null);

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "2.5-\\u2013-build-[error]-v2",
  transform: "translate(-472.000000, -455.000000)",
  fill: "#FF4D4D",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "noun_Warning_1076058",
  transform: "translate(472.000000, 455.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M26,51.7189189 C40.1945946,51.7189189 51.7189189,40.1945946 51.7189189,26 C51.7189189,11.8054054 40.1945946,0.281081081 26,0.281081081 C11.8054054,0.281081081 0.281081081,11.8054054 0.281081081,26 C0.281081081,40.1945946 11.8054054,51.7189189 26,51.7189189 Z M26,4.4972973 C37.8756757,4.4972973 47.5027027,14.1243243 47.5027027,26 C47.5027027,37.8756757 37.8756757,47.5027027 26,47.5027027 C14.1243243,47.5027027 4.4972973,37.8756757 4.4972973,26 C4.4972973,14.1243243 14.1243243,4.4972973 26,4.4972973 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M26.2810811,30.2162162 C27.4756757,30.2162162 28.3891892,29.3027027 28.3891892,28.1081081 L28.3891892,14.7567568 C28.3891892,13.5621622 27.4756757,12.6486486 26.2810811,12.6486486 C25.0864865,12.6486486 24.172973,13.5621622 24.172973,14.7567568 L24.172973,28.1081081 C24.172973,29.3027027 25.1567568,30.2162162 26.2810811,30.2162162 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M26.2810811,40.0540541 C27.4756757,40.0540541 28.3891892,39.1405405 28.3891892,37.9459459 L28.3891892,35.8378378 C28.3891892,34.6432432 27.4756757,33.7297297 26.2810811,33.7297297 C25.0864865,33.7297297 24.172973,34.6432432 24.172973,35.8378378 L24.172973,37.9459459 C24.172973,39.1405405 25.1567568,40.0540541 26.2810811,40.0540541 Z",
  id: "Path"
})))));

const SvgErrorRound = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgErrorRound, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error-round.19faa315.svg";
export { ForwardRef as ReactComponent };